import React, { useEffect, useRef } from 'react';
import { FaFileExcel, FaFilePdf, FaImage, FaFile } from 'react-icons/fa';
import './FileReferenceDropdown.css';

const FILE_ICONS = {
  excel: { icon: FaFileExcel, color: '#217346' },
  csv: { icon: FaFileExcel, color: '#217346' },
  pdf: { icon: FaFilePdf, color: '#dc2626' },
  image: { icon: FaImage, color: '#7c3aed' },
  default: { icon: FaFile, color: '#6b7280' }
};

const FileReferenceDropdown = ({
  isOpen,
  files = [],
  searchText = '',
  onSelect,
  onClose,
  selectedIndex = 0,
  position
}) => {
  const dropdownRef = useRef(null);

  // Filtrar archivos por texto de busqueda (con validaciones)
  const safeSearchText = (searchText || '').toLowerCase();
  const filteredFiles = (files || []).filter(file =>
    file.original_name?.toLowerCase().includes(safeSearchText)
  );

  // Obtener icono segun tipo de archivo
  const getFileIcon = (fileType) => {
    return FILE_ICONS[fileType] || FILE_ICONS.default;
  };

  // Formatear fecha
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: 'short'
    });
  };

  // Cerrar al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen || filteredFiles.length === 0) {
    return null;
  }

  return (
    <div
      ref={dropdownRef}
      className="file-reference-dropdown"
      style={position}
    >
      <div className="file-dropdown-header">
        <span>Archivos disponibles</span>
      </div>

      <div className="file-dropdown-list">
        {filteredFiles.map((file, index) => {
          const { icon: FileIcon, color } = getFileIcon(file.file_type);
          const isSelected = index === selectedIndex;

          return (
            <div
              key={file.id}
              className={`file-dropdown-item ${isSelected ? 'selected' : ''}`}
              onClick={() => onSelect(file)}
              onMouseEnter={() => {}}
            >
              <div className="file-item-icon" style={{ backgroundColor: color }}>
                <FileIcon size={14} />
              </div>
              <div className="file-item-info">
                <span className="file-item-name" title={file.original_name}>
                  {file.original_name}
                </span>
                <span className="file-item-meta">
                  {file.file_size_formatted} - {formatDate(file.uploaded_at)}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="file-dropdown-footer">
        <span>Usa flechas para navegar - Enter para seleccionar</span>
      </div>
    </div>
  );
};

export default FileReferenceDropdown;
